import React from "react";
import { TESTIMONIALS } from "../config/siteConfig";

const StarIcon: React.FC<{ filled: boolean }> = ({ filled }) => (
  <svg className="w-4 h-4" viewBox="0 0 20 20" fill={filled ? "#BB9D63" : "#333"}>
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

const Testimonials: React.FC = () => {
  return (
    <section className="py-24 bg-zinc-950">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-amber-600/60 tracking-[0.3em] uppercase text-xs mb-4">
            Témoignages
          </p>
          <h2
            className="text-4xl md:text-5xl font-display"
            style={{ color: "#BB9D63" }}
          >
            Ce qu'ils en disent
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="p-8 bg-black/50 border border-white/5 rounded-sm hover:border-amber-800/20 transition-all duration-500"
            >
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, j) => (
                  <StarIcon key={j} filled={j < t.rating} />
                ))}
              </div>
              <p className="text-zinc-400 text-sm leading-relaxed mb-6 italic">
                "{t.text}"
              </p>
              <div>
                <p className="text-white text-sm font-medium">{t.name}</p>
                <p className="text-zinc-600 text-xs mt-0.5">{t.event}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
